// import get from 'lodash/get';
import { handleError } from 'helper/rest';
import { client } from 'helper/axios';
// import { setCookie } from 'helper/cookie';
// import { parseJWT } from 'helper/jwt';
// import Swal from 'sweetalert2';
// import Color from 'constants/color.constants';

export const getAnnounceOwnerAll = async ({ token, params } : any) => {
   try {
      return await client
         .get(`announce_owner`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            params,
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getAnnounceOwnerById = async ({ token, params } : any) => {
   try {
      return await client
         .get(`announce_owner/${params?.id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getAnnounceOwnerByGroupUserId = async ({ token, params } : any) => {
   try {
      return await client
         .get(`announce_owner_group_user_id`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const postCreateAnnounceOwner = async ({ token, params } : any) => {
   try {
      return await client
         .post(`announce_owner`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const putUpdateAnnounceOwner = async ({ token, params, id } : any) => {
   try {
      return await client
         .put(`announce_owner/${id}`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const deleteAnnounceOwner = async ({ token, id } : any) => {
   try {
      return await client
         .delete(`announce_owner/${id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const postExportLimitnumberExcel = async ({ token, params } : any) => {
   try {
      return await client
         .post(`limitnumber_export_excel`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            responseType: 'blob', // ระบุว่า response ที่คาดหวังคือ blob
         })
         .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            // link.setAttribute('download', `receipt.xlsx`); // ตั้งชื่อไฟล์ที่ดาวน์โหลด
            link.setAttribute('download', `นำข้อมูลเลขอั้นออกงวดเลขไอดีที่_${params.limitnumber_period_id}.xlsx`); // ตั้งชื่อไฟล์ที่ดาวน์โหลด
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // คืนทรัพยากร URL

            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};